"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExternSurface = ExternSurface;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _styles = require("@mui/material/styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var LogoImg = (0, _styles.styled)('img')(function (_ref) {
  var theme = _ref.theme;
  return {};
});
function ExternSurface(props) {
  return /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12,
    sm: props.sm || 10,
    md: props.md || 6,
    lg: props.lg || 4,
    xl: props.xl || 3
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    my: 4
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true,
    justifyContent: "center",
    alignItems: "center"
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 11,
    lg: 12
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true,
    justifyContent: "center",
    alignItems: "center"
  }, /*#__PURE__*/_react["default"].createElement(LogoImg, {
    src: "/focaltec_192.jpg",
    alt: props.appTitle
  }), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12
  }, props.showTitle && props.title && (/*#__PURE__*/_react["default"].createElement(_material.Typography, {
    component: "h6",
    variant: "h6",
    align: "center",
    gutterBottom: true
  }, props.title)), props.description && (/*#__PURE__*/_react["default"].createElement(_material.Typography, {
    component: "p",
    variant: "body1",
    align: "center"
  }, props.description)))), props.children))));
}